import { marqueeItems } from '@/mocks/strategix';

export default function Marquee() {
  const items = [...marqueeItems, ...marqueeItems];

  return (
    <section className="w-full border-y border-background-200/70 bg-background-100/60 py-5 overflow-hidden">
      <div className="flex w-max animate-marquee">
        {items.map((item, index) => (
          <span
            key={`${item}-${index}`}
            className="flex items-center gap-4 px-6 font-heading text-sm md:text-base text-foreground-700 whitespace-nowrap"
          >
            <i className="ri-flashlight-fill text-primary-400 text-base"></i>
            {item}
          </span>
        ))}
      </div>
    </section>
  );
}